import { useOutletContext } from "react-router-dom";
import { Code2 } from "lucide-react";
import ChatStudio from "@/components/ChatStudio";

const CODE_SYSTEM =
  "Tu es CRÉRÉA Code, un agent de programmation expert. Tu écris du code clair, correct et idiomatique. " +
  "Réponds en français. Fournis toujours le code dans des blocs ```langage. Explique brièvement les choix importants, " +
  "propose des tests quand c'est pertinent, et signale les pièges de sécurité ou de performance.";

export default function CodeAgent() {
  const { refreshCredits } = useOutletContext();
  return (
    <div className="space-y-6" data-testid="code-page">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold-400">CRÉRÉA · Code</p>
        <h1 className="mt-1 flex items-center gap-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">
          <Code2 className="h-7 w-7 text-gold-400" />L'agent de code
        </h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Un copilote de programmation branché sur la passerelle CRÉRÉA. Décrivez une fonctionnalité, collez une erreur,
          demandez un refactor — le fil de conversation est conservé pour itérer sans repartir de zéro.
        </p>
      </div>
      <ChatStudio kind="code" system={CODE_SYSTEM} mono defaultModel="crerea-gpt" onCredits={refreshCredits}
        placeholder="Ex : Écris une fonction Python qui parse un CSV et gère les erreurs…" />
    </div>
  );
}
